// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contentDiv[data-v-36492a49] {\n  border-radius: 12px 12px 0 0;\n  border: 1px solid #db4e1a;\n  padding-top: 0.1rem;\n  margin-bottom: 0.07rem;\n}\n", ""]);
// Exports
module.exports = exports;
